import ProjectWorld, { ProjectLocalEvent, ProjectWorldEntities, ProjectWorldEntityTypes, ProjectMetadata } from "@/ProjectWorld";
import { inject, injectable } from "tsyringe";
import { TOKEN_ILocalData, type ILocalData } from "./LocalData";

export const TOKEN_IProjectWorldWriter = Symbol('IProjectWorldWriter');

export interface IProjectWorldWriter {
    saveProjectWorldMetadata(projectMetadata: ProjectMetadata): Promise<void>;
    replaceWorld(oldWorld: ProjectWorld, newWorld: ProjectWorld): Promise<void>;
    saveProjectWorld(
        projectMetadata: ProjectMetadata,
        events: ProjectLocalEvent[],
        entitiesToSave: Map<string, Set<ProjectWorldEntities>>): Promise<void>;
    deleteProjectWorld(projectId: string): Promise<void>;
}

@injectable()
export class ProjectWorldWriter implements IProjectWorldWriter {

    constructor(
        @inject(TOKEN_ILocalData) private localData: ILocalData,
    ) { }

    saveProjectWorldMetadata = async (projectMetadata: ProjectMetadata): Promise<void> => {
        await this.localData.store.writeAll(async (writer) => {
            await writer.aggregates.put(projectMetadata);
        });
    }

    replaceWorld = async (oldWorld: ProjectWorld, newWorld: ProjectWorld): Promise<void> => {
        await this.localData.store.replaceWorld(newWorld.projectMetadata, oldWorld.getAllEntityCollections(), newWorld.getAllEntityCollections());
    }

    deleteProjectWorld = async (projectId: string): Promise<void> => {
        await this.localData.store.deleteAggregate(projectId);
    }

    saveProjectWorld = async (projectMetadata: ProjectMetadata, events: ProjectLocalEvent[], entitiesToSave: Map<ProjectWorldEntityTypes, Set<ProjectWorldEntities>>) => {
        await this.localData.store.saveWorld(projectMetadata, events, entitiesToSave);
    }
}